import { ArrowsControlState, } from '@kubit/web-ui-components/pageControl/types';
import { ArrowsControlVariant } from '../variants';
export const getArrowControlStyles = (FOUNDATIONS, FONT) => {
    return {
        [ArrowsControlVariant.ARROW_CONTROL]: {
            [ArrowsControlState.INACTIVE]: {},
            [ArrowsControlState.ACTIVE]: {},
        },
    };
};
//# sourceMappingURL=arrowControl.js.map